import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone_plugin from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone_plugin);

// Timezone used when the organization does not have one configured
export const DEFAULT_TIMEZONE = 'America/Mexico_City';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm:ss';

// Resolves the timezone of an organization info object, falling back to the default one
export const resolve_org_timezone = (organization_info) => {
	const org_timezone = organization_info?.timezone;

	return org_timezone
		? { timezone: org_timezone, is_fallback: false }
		: { timezone: DEFAULT_TIMEZONE, is_fallback: true };
}

/*
	Formats a dayjs without wrapping it again, as re-wrapping a timezone aware object
	moves it to the browser timezone and could shift the calendar day
*/
const format_dayjs = (value, format) => (
	dayjs.isDayjs(value) ? value.format(format) : dayjs(value).format(format)
);

// Combines a date and a time (both dayjs objects) into an epoch in the organization timezone
export const org_date_time_to_epoch = (date, time, tz) => {
	const date_str = format_dayjs(date, DATE_FORMAT);
	const time_str = format_dayjs(time, TIME_FORMAT);

	// Milliseconds are dropped as the cycles are stored with seconds precision
	return dayjs.tz(`${date_str} ${time_str}`, tz || DEFAULT_TIMEZONE).millisecond(0).valueOf();
}

// Converts an epoch into a dayjs object placed in the organization timezone
export const epoch_to_org_dayjs = (epoch, tz) => {
	return dayjs(epoch).tz(tz || DEFAULT_TIMEZONE);
}

// Start of the day (00:00:00) as a dayjs object, used as the default start time
export const org_day_start = () => dayjs().startOf('day');

// End of the day (23:59:59) as a dayjs object, used as the default end time
export const org_day_end = () => dayjs().endOf('day').millisecond(0);

// Reads the wall clock time of a dayjs, respecting its timezone
export const time_of_day = (value) => format_dayjs(value, TIME_FORMAT);

// Checks if a dayjs time matches the default start (00:00:00) or end (23:59:59) of the day
export const is_default_day_start = (time) => time_of_day(time) === '00:00:00';
export const is_default_day_end = (time) => time_of_day(time) === '23:59:59';
